// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f3d1056c","455":"fef5db5f","977":"72ca681d"}[chunkId] + ".chunk.js";
};